"use client";

import r, { createContext as n, useContext as i } from "react";
let e = n(() => {});
function u() {
  return i(e);
}
function C(_ref) {
  let {
    value: t,
    children: o
  } = _ref;
  return r.createElement(e.Provider, {
    value: t
  }, o);
}
export { C as CloseProvider, u as useClose };